import { collection, onSnapshot, addDoc, doc, setDoc, deleteDoc } from "firebase/firestore"
import { config } from "@/utils/configuration/config"
import { db } from "@/fb.js"

import Ship from "@/model/Ship"
import CarbonService from "@/services/CarbonService"
import CarbonElementType from "@/model/CarbonElementType"
import ConfigurationForCarbonType from "@/model/ConfigurationForCarbonType"

class CarbonRepo {
    private service: CarbonService

    public constructor(service: CarbonService) {
        this.service = service
    }

    public getCarbonData(ship: Ship) {
        onSnapshot(
            collection(db, config.firebaseConfig.shipsCollectionName, ship.id, "CarbonData"),
            (querySnapshot) => {
                console.log("CarbonRepo-getCarbonData")
                const changes = querySnapshot.docChanges()

                changes.forEach(async (change) => {
                    if (change.type === "added") {
                        console.log("CarbonRepo-getCarbonData added", change.doc.id)
                        this.service.addedCarbonData(
                            ship,
                            change.doc.id,
                            this.getCarbonDataFromFirebase(change.doc.data())
                        )
                    } else if (change.type === "modified") {
                        console.log("CarbonRepo-getCarbonData modified", change.doc.id)
                        this.service.modifiedCarbonData(
                            ship,
                            change.doc.id,
                            this.getCarbonDataFromFirebase(change.doc.data())
                        )
                    } else if (change.type === "removed") {
                        console.log("CarbonRepo-getCarbonData removed", change.doc.id)
                        // this.service.removedCarbonData(ship, change.doc.id)
                    }
                })
            }
        )
    }

    saveCarbonData(ship: Ship, carbonData: CarbonElementType) {
        const objectToSave = this.getCarbonDataForFirebase(carbonData)

        let errors = ""
        try {
            console.log("CarbonRepo.saveCarbonData Object to save:", objectToSave)
            if (ship.carbonData && ship.carbonData.id) {
                console.log("CarbonRepo.saveCarbonData Actualizando objeto", ship.carbonData.id)
                const ecoRef = doc(
                    db,
                    config.firebaseConfig.shipsCollectionName,
                    ship.id,
                    "CarbonData",
                    ship.carbonData.id
                )
                setDoc(ecoRef, objectToSave)
            } else {
                addDoc(collection(db, config.firebaseConfig.shipsCollectionName, ship.id, "CarbonData"), objectToSave)
            }
        } catch (error) {
            console.log("CarbonRepo.saveCarbonData ERROR:", error)
            errors += error
        }

        return errors
    }

    private getCarbonDataForFirebase(carbonData: CarbonElementType) {
        const objectToSave: any = {
            ...carbonData
        }

        objectToSave.configurationsForCarbon = new Array()
        carbonData.configurationsForCarbon.forEach((configurationForCarbon) => {
            const configurationToSave = {
                configurationName: configurationForCarbon.configurationName,
                resultsForConfiguration: configurationForCarbon.resultsForConfiguration,
                modified_gt: configurationForCarbon.modified_gt,
                modified_dwt: configurationForCarbon.modified_dwt,
                fuelInfo: new Array()
            }

            configurationForCarbon.fuelInfo.forEach((fuelInfo) => {
                configurationToSave.fuelInfo.push({
                    ...fuelInfo
                })
            })

            objectToSave.configurationsForCarbon.push(configurationToSave)
        })

        delete objectToSave.id

        return objectToSave
    }

    private getCarbonDataFromFirebase(carbonDataFromFirebase): CarbonElementType {
        console.log("carbonRepo-getCarbonDataFromFirebase. From firebase =", carbonDataFromFirebase)

        const result = new CarbonElementType()

        result.distancePerYear = carbonDataFromFirebase.distancePerYear
        result.id = carbonDataFromFirebase.id

        carbonDataFromFirebase.configurationsForCarbon.forEach((configurationForCarbonElement) => {
            const configurationForCarbon = new ConfigurationForCarbonType()
            configurationForCarbon.configurationName = configurationForCarbonElement.configurationName
            configurationForCarbon.resultsForConfiguration = configurationForCarbonElement.resultsForConfiguration
            configurationForCarbon.modified_dwt = configurationForCarbonElement.modified_dwt
            configurationForCarbon.modified_gt = configurationForCarbonElement.modified_gt

            configurationForCarbonElement.fuelInfo.forEach((fuelInfoElement) => {
                configurationForCarbon.fuelInfo.push({
                    ...fuelInfoElement
                })
            })

            result.configurationsForCarbon.push(configurationForCarbon)
        })

        console.log("carbonRepo-getCarbonDataFromFirebase. Result =", result)

        return result
    }
}

export default CarbonRepo
